import '../css/app.css';
import './echo';
import './axios-config'; // Installs axios response interceptor that redirects to login on 419/401.

import { createInertiaApp, router } from '@inertiajs/react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/ro'; // Import Romanian locale
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { showToast } from './components/notification';
import { initializeTheme } from './hooks/use-appearance';
import ThemeCustomization from './themes';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./pages/${name}.jsx`, import.meta.glob('./pages/**/*.jsx')),
    setup({ el, App, props }) {
        const root = createRoot(el);

        root.render(
            <ThemeCustomization>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ro">
                    <App {...props} />
                </LocalizationProvider>
            </ThemeCustomization>,
        );
    },
    progress: {
        color: '#4B5563',
    },
    prefetch: false, // Disable prefetching on hover
});

// This will set light / dark mode on load...
initializeTheme();

router.on('exception', () => {
    showToast('error', 'A apărut o eroare. Reîncărcați pagina dacă problema persistă.');
});
